import { type BaseTemplateProps } from '../NotificationTemplate'
import { type TemplateDefinition } from '../TemplateRegistry'

interface QasBatchAssignedProps extends BaseTemplateProps {
  batchId: string
  workflowName: string
  batchLink: string
}

export const QasBatchAssigned: TemplateDefinition<QasBatchAssignedProps> = {
  renderParams: (props: QasBatchAssignedProps) => ({
    messageKey: 'notificationsDomain.templates.qasBatchAssigned',
    values: {
      batchId: props.batchId,
      workflowName: props.workflowName,
    },
  }),
  getLink: (props: QasBatchAssignedProps): string => props?.batchLink || '',
}
